export default __webpack_public_path__ + "static/media/farm_challenge_pesticide_overuse.cd431322.jpg";